import { useQuery } from 'react-query';
import { API_GET_RELEASE_NOTE, API_GATEWAY } from '../../helpers/api';
import { maestroApiCall } from '../..';
export var useGetReleaseNotes = function (application, currentLanguage) {
    var endpoint = "".concat(API_GET_RELEASE_NOTE, "/").concat(application, "?$limit=1000&language=").concat(currentLanguage !== null && currentLanguage !== void 0 ? currentLanguage : '');
    return useQuery(['release_notes', application, currentLanguage], function () { return (maestroApiCall({ method: 'GET', endpoint: endpoint, baseURL: API_GATEWAY })); }, { staleTime: Infinity });
};
//# sourceMappingURL=useGetReleaseNotes.js.map